export const commonStrings = {
  signUp: {
    notValid: "This link is no longer valid",
    linkExpired:
      " The invitation link you’re trying to access has expired or is no longer active.",
  },
  sideBarMenuTitles: {
    assemblyConstituency: "Assembly Constituency",
    zone: "Zone",
    rio: "RIO",
  },
};
